import { registerArchetype } from './index.js';
import { applyHeal, livingAllies } from '../combat.js';
registerArchetype({
    id: 'heal',
    apply: ({ state, source, params }) => {
        const flat = params.flat ?? 0;
        const targetMode = params.target ?? 'lowest_hp';
        const allies = livingAllies(state, source.side);
        if (allies.length === 0)
            return;
        if (targetMode === 'all') {
            for (const a of allies)
                applyHeal(state, { side: source.side, slot: a.slot }, flat);
            return;
        }
        const target = allies.reduce((m, a) => a.runtime.hp / a.runtime.hpMax < m.runtime.hp / m.runtime.hpMax ? a : m);
        applyHeal(state, { side: source.side, slot: target.slot }, flat);
    }
});
